import * as Yup from 'yup';

export const AddBullionDeskValidationSchema = Yup.object().shape({
  unit: Yup.string().required('Unit is required'),
  type: Yup.string().required('Type is required'),
  start: Yup.string().required('Start Date is required'),
  expiry: Yup.string().required('End Date is required'),
  operationLocationId: Yup.string().required('Operation Location is required'),
  buy: Yup.number()
    .required('Buy price is required')
    .integer('Must be an integer')
    .positive('Must be a positive number'),
  sell: Yup.number()
    .required('Sell price is required')
    .integer('Must be an integer')
    .positive('Must be a positive number'),
  threshold_sell: Yup.number()
    .required('Customer Sell Quantity Threshold is required')
    .integer('Must be an integer')
    .positive('Must be a positive number'),
  threshold_buy: Yup.number()
    .required('Customer Sell Quantity Threshold is required')
    .integer('Must be an integer')
    .positive('Must be a positive number'),
  threshold_sell_addon: Yup.number()
    .required('Sell Subtract is required')
    .integer('Must be an integer')
    .positive('Must be a positive number'),
  threshold_buy_addon: Yup.number()
    .required('Buy addon is required')
    .integer('Must be an integer')
    .positive('Must be a positive number'),
}).test(
  'buy-greater-than-sell',
  'Buy price must be greater than or equal to Sell price',
  function (value) {
    const { buy, sell } = value;
    if (buy && sell && buy < sell) {
      return this.createError({
        path: 'buy',
        message: 'Buy price must be greater than or equal to Sell price',
      });
    }
    return true;
  }
);
